<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <!-- <search-form :fields="search" /> -->
      <el-button v-if="hasPermsCreate" @click="onCreate()">新增</el-button>
      <!-- <el-button @click="onExpand">展开</el-button>
      <el-button @click="onCollapse">收起</el-button>
      <loading-action :action="onSaveOrder">保存</loading-action> -->
    </el-button-group>

    <el-table
      :data="goodsCategories"
      resource="goodsCategories"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="code" label="编码" />
      <el-table-column prop="title" label="名称" />
      <el-table-column label="图标">
        <template slot-scope="scope">
          <file-preview v-if="scope.row.pic !== ''" :file="scope.row.pic" />
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" sortable width="180" />

      <el-table-column label="状态" width="180">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" disabled :active-value="1" :inactive-value="0" />
        </template>
      </el-table-column>

      <el-table-column prop="remark" label="备注" />
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button-group>
            <button-link v-if="hasPermsCreate" size="small" :to="`/goods-categories/create?parent_id=${scope.row.id}`">
              添加子项
            </button-link>
            <button-link v-if="hasPermsEdit" size="small" :to="`/goods-categories/${scope.row.id}/edit`">编辑</button-link>
            <pop-confirm type="danger" size="small" :confirm="onDestroy(scope.row)" notice="所有子路由都会被删除！！！">
              删除
            </pop-confirm>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { destroyGoodsCategory, getGoodsCategories, updateGoodsCategories } from '@/api/goods-categories'

import { can, getMessage, hasChildren, removeFromNested } from '@/libs/utils'
import ButtonLink from '@c/ButtonLink'
import FilePreview from '@c/FilePreview'
import PopConfirm from '@c/PopConfirm'
import SearchForm from '@c/SearchForm'

export default {
  name: 'Index',
  components: {
    ButtonLink,
    SearchForm,
    PopConfirm,
    FilePreview,
  },
  data() {
    return {
      search: [
        // {
        //   field: 'code',
        //   label: '编码',
        // },
        // {
        //   field: 'title',
        //   label: '名称',
        // },
        // {
        //   field: 'status',
        //   label: '状态',
        //   type: 'el-select',
        //   options: [
        //     { id: 1, name: '已启用' },
        //     { id: 0, name: '已禁用' },
        //   ],
        //   labelField: 'name', // 默认为 name
        //   valueField: 'id', // 默认为 id
        // },
      ],
      goodsCategories: [],
      visible: false,
      // 默认展开第二级路由
      defaultExpanded: [],
      hasPermsCreate: false,
      hasPermsEdit: false,
    }
  },
  created() {
    this.getGoodsCategories()
    this.hasPermsCreate = can('goods-categories.create')
    this.hasPermsEdit = can('goods-categories.edit')
  },
  methods: {
    async getGoodsCategories() {
      const { data } = await getGoodsCategories()
      this.goodsCategories = data
      this.defaultExpanded = this.goodsCategories.filter(i => hasChildren(i)).map(i => i.id)
    },
    onDestroy(row) {
      return async () => {
        await destroyGoodsCategory(row.id)
        this.$message.success(getMessage('destroyed'))
        removeFromNested(this.goodsCategories, row.id)
      }
    },
    hasChildren,
    onCreate() {
      this.$router.push('/goods-categories/create')
    },
    onExpand() {
      this.$refs.routers.expandAll()
    },
    onCollapse() {
      this.$refs.routers.collapseAll()
    },
    /**
     * 获取路由结构，仅包含 id 和 children 字段
     * @param goodsCategories
     * @returns {Array}
     */
    getShopMealStruct(goodsCategories = this.goodsCategories) {
      const struct = []
      goodsCategories.forEach(i => {
        struct.push({
          id: i.id,
          children: hasChildren(i) ? this.getShopMealStruct(i.children) : undefined,
        })
      })
      return struct
    },
    async onSaveOrder() {
      await updateGoodsCategories({
        _order: this.getShopMealStruct(this.goodsCategories),
      })
      this.$message.success(getMessage('updated'))
    },
  },
}
</script>

<style scoped lang="scss">
@import '~element-ui/packages/theme-chalk/src/common/var';

.goods-categories {
  width: 800px;

  .id {
    width: 40px;
    display: inline-block;
    text-align: center;
    font-weight: bolder;
  }

  .path {
    color: $--color-primary;
  }

  .drag-zone {
    cursor: move;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
